// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-views-index-index-jsx": () => import("./../src/views/index/index.jsx" /* webpackChunkName: "component---src-views-index-index-jsx" */),
  "component---src-views-index-white-paper-jsx": () => import("./../src/views/index/white-paper.jsx" /* webpackChunkName: "component---src-views-index-white-paper-jsx" */),
  "component---src-views-search-search-jsx": () => import("./../src/views/search/search.jsx" /* webpackChunkName: "component---src-views-search-search-jsx" */),
  "component---src-templates-post-jsx": () => import("./../src/templates/post.jsx" /* webpackChunkName: "component---src-templates-post-jsx" */),
  "component---src-templates-document-jsx": () => import("./../src/templates/document.jsx" /* webpackChunkName: "component---src-templates-document-jsx" */),
  "component---src-templates-export-jsx": () => import("./../src/templates/export.jsx" /* webpackChunkName: "component---src-templates-export-jsx" */)
}

